// ISCO-08 ana grupları — meslek biriminin (isco_group) ilk hanesi. 10 kararlı,
// resmî kova; keşif filtresi ve picker alt satırında kullanılır. Grup adları
// i18n'den çözülür (t('isco.<code>')) — bkz i18n/en.ts, tr.ts.
export const ISCO_MAJOR_CODES = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'] as const;

// Bir meslek birim kodundan ana grup hanesini al. '2512' → '2', '0310' → '0'.
export function iscoMajorOf(iscoGroup: string | null | undefined): string {
  return iscoGroup && iscoGroup.length > 0 ? iscoGroup[0] : '';
}
